import { Component } from '@angular/core';
import { RepoSettingsService } from '../../../../data/repositories/repo-settings.service';
import { Router } from '@angular/router';
import { RouterStateService } from '../../../../core/routing/router-state.service';

@Component({
    selector: 'sidebar2-menulock-angular',
    templateUrl: './sidebar2-menulock-angular.component.html',
    standalone: false,
})
export class Sidebar2MenulockAngularComponent {
    constructor(
        private router: Router,
        private routerStateService: RouterStateService,
        private settings: RepoSettingsService
    ) {}

    onToggleCollapse() {
        this.settings.ShowExplorePanel = false;
        this.settings.ShowMyProfilePanel = false;
        this.settings.ShowIntegrationsPanel = false;
        this.routerStateService.reloadCurrent({ subpanel: 'false' });
    }
}
